document.addEventListener("click", (e) => {
  if (!e.target.classList.contains("dropdown-menu") && !e.target.tagName == "SUMMARY") _closeAllDropdowns(document);
});

function _closeAllDropdowns (target) {
  const openDropdowns = target.querySelectorAll('header details[open]');
  openDropdowns.forEach(dropdown => {
    dropdown.removeAttribute("open");
  })
};
